import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";
import H1 from "../typography/H1";

const Wrapper = styled.div`
  position: relative;
  height: 120px;
  width: 100%;
  overflow: hidden;
`;

const Overlay = styled.div`
  width: 100%;
  background-color: ${colors.backgroundPrimary};
  inset: 0;
  height: 100%;
`;

const Inner = styled.div`
  z-index: 1;
  width: fit-content;
  height: 100%;
  margin: auto;
  display: flex;
  align-items: center;
  gap: 32px;
  text-align: center;
  color: ${colors.black};

  h1 {
    font-weight: 600;
    letter-spacing: -0.5px;
  }

  input {
    padding: 14px 18px;
    border: 1px solid ${colors.border};
    border-radius: 4px;
    font-size: ${fontSize.m};
    width: 380px;
    background: ${colors.backgroundPrimary};
    color: ${colors.black};
    outline: none;
    transition: all 0.25s ease-in-out;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  input:focus {
    border-color: ${colors.black};
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
  }

  button {
    padding: 14px 28px;
    border: 1px solid ${colors.black};
    border-radius: 4px;
    background: ${colors.black};
    color: ${colors.backgroundPrimary};
    cursor: pointer;
    font-size: ${fontSize.m};
    font-weight: 500;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    transition: all 0.25s ease-in-out;
  }

  button:hover {
    background: transparent;
    color: ${colors.black};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }

  @media (max-width: 800px) {
    gap: 20px;
    h1 {
      font-size: ${fontSize.l};
    }
    input {
      width: 260px;
      font-size: ${fontSize.s};
    }
    button {
      font-size: ${fontSize.s};
      padding: 12px 20px;
    }
  }

  @media (max-width: 500px) {
    gap: 12px;
    h1 {
      display: none;
    }
    input {
      width: 180px;
      font-size: ${fontSize.xs};
      padding: 10px 12px;
    }
    button {
      font-size: ${fontSize.xs};
      padding: 10px 14px;
    }
  }
`;

function SearchBanner() {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");

  const handleSearch = () => {
    if (query.trim()) {
      window.location= (`/products?q=${encodeURIComponent(query)}`);
    }
  };

  return (
    <Wrapper>
      <Overlay>
        <Inner>
          <H1>Discover</H1>
          <input
            type="text"
            placeholder="Search for products..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
          <button onClick={handleSearch}>Search</button>
        </Inner>
      </Overlay>
    </Wrapper>
  );
}

export default SearchBanner;
